import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import { UserAccessService } from '@merchant-portal/app/core/user-access/services/user-access.service';
import { IconsComponent } from 'ui-component/src/lib/icons';
import { LogoComponent } from 'ui-component/src/lib/logo/logo.component';
import { SvgLoaderModule } from '../icon/svg-loader/svg-loader/svg-loader.module';
import { SidebarComponent } from './sidebar.component';

@NgModule({
  declarations: [SidebarComponent],
  exports: [SidebarComponent],
  providers: [UserAccessService],
  imports: [
    CommonModule,
    MatTreeModule,
    RouterModule,
    SvgLoaderModule,
    LogoComponent,
    IconsComponent,
  ],
})
export class SidebarMenuModule {}
